import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * Wraps protected routes. Redirects to /login when the user is unauthenticated,
 * preserving the attempted path so we can bounce them back after login.
 *
 * Shows a spinner during the initial session hydration so we don't flash-redirect
 * a user who IS logged in but whose session hasn't been read from localStorage yet.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" sx={{ minHeight: 'calc(100vh - 64px)' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
